export default "__VITE_ASSET__Du8T2p1z__"